function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeMiterlimit: 10,
  d: "M33.08,24.065c0,4.799-3.89,8.688-8.688,8.688l0,0 c-4.798,0-8.688-3.889-8.688-8.688v-0.17c0-4.799,3.89-8.688,8.688-8.688l0,0c4.799,0,8.688,3.89,8.688,8.688V24.065z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  d: "M26.648,20.941c0,1.246-1.011,2.258-2.257,2.258l0,0 c-1.247,0-2.257-1.012-2.257-2.258v-0.256c0-1.246,1.01-2.257,2.257-2.257l0,0c1.246,0,2.257,1.011,2.257,2.257V20.941z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  d: "M28.821,28.351c0,0,0.494,0-4.43,0c-1.602,0-4.429,0.134-4.429,0 c0-2.657,1.983-4.812,4.429-4.812C26.839,23.539,28.821,25.694,28.821,28.351z"
});

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.05403991.svg";
export { ForwardRef as ReactComponent };